/* eslint-disable no-shadow */
import { call, takeEvery } from "redux-saga/effects";
import noop from "lodash.noop";
import { getId, injectApiWithContextFactory, injectBoundActionCreatorsFactory } from "Utils/sagaUtils";
import { injectBoundGQLClient } from "Utils/injectBoundGQLClient";
import { getUserContext, saveUserContextFeatureFavourites } from "./featureSelection.api";
import {
  AI_FEATURE_SELECTION_LOAD_REQUESTED,
  AI_FEATURE_SELECTION_SAVE_REQUESTED,
  appMngmtId,
  loadFeatureSelectionFail,
  loadFeatureSelectionSuccess,
  saveFeatureSelectionFail,
  saveFeatureSelectionSuccess,
} from "./featureSelection.duck";

export const withBoundActions = injectBoundActionCreatorsFactory(
  {
    loadFeatureSelectionFail,
    loadFeatureSelectionSuccess,
    saveFeatureSelectionFail,
    saveFeatureSelectionSuccess,
  },
  () => appMngmtId
);

export const withApiContext = injectApiWithContextFactory(
  {
    getUserContext,
    saveUserContextFeatureFavourites
  },
  injectBoundGQLClient
);

function* loadFeatureSelection({
  api: { getUserContext = noop },
  actions: { loadFeatureSelectionFail = noop, loadFeatureSelectionSuccess = noop },
  resolve = noop,
  reject = noop,
}) {
  try {
    const featureSelection = yield getUserContext();
    yield loadFeatureSelectionSuccess(featureSelection);
    yield call(resolve);
  } catch (error) {
    yield loadFeatureSelectionFail(error);
    yield call(reject);
  }
}

function* saveFeatureSelection({
  data,
  api: { saveUserContextFeatureFavourites = noop },
  actions: { saveFeatureSelectionFail = noop, saveFeatureSelectionSuccess = noop },
  resolve = noop,
  reject = noop,
}) {
  try {
    const featureFavourites = yield saveUserContextFeatureFavourites({ formValues: data });
    yield saveFeatureSelectionSuccess(featureFavourites);
    yield call(resolve);
  } catch (error) {
    yield saveFeatureSelectionFail(error);
    yield call(reject);
  }
}

export default () =>
  function* rootSaga() {
    yield takeEvery(AI_FEATURE_SELECTION_LOAD_REQUESTED, withApiContext(withBoundActions(loadFeatureSelection)));
    yield takeEvery(AI_FEATURE_SELECTION_SAVE_REQUESTED, withApiContext(withBoundActions(saveFeatureSelection)));
  };
